import { API_BASE_URL } from "../../config"
import request from "../../utilities/request"

const createAmpCategory = (data) => request.post(`${API_BASE_URL}/blockchain/category`, data)

export default createAmpCategory